import { render, staticRenderFns } from "./ObjectCreater.vue?vue&type=template&id=3cc0a306&"
import script from "./ObjectCreater.vue?vue&type=script&lang=js&"
export * from "./ObjectCreater.vue?vue&type=script&lang=js&"
import style0 from "./ObjectCreater.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports